import { ClassNames } from '@emotion/react';
import { Button, Paper, Stack, Typography, styled } from '@mui/material';
import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import classes from '../Layout/Sidebar.module.css'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { UserContext } from '../../hooks/UserContext';
import { DUAL_ACCOUNT_REPORT, PART_D_PREDETERMINATION_REPORT, INBOUND_CORR_WB_REPORT, PART_D_DUPLICATE_REPORT, PART_D_IE_REPORT, PART_D_MULTIPLE_REPORT, RESOLVED_COMPLETED_REPORT, TRANSITIONAL_OVERRIDE_REPORT, UHCEI_DUPLICATE_DENIAL_REPORT, XCPINDEXING_REPORT } from '../../constants/reportNames';
import { HelpOutline } from '@mui/icons-material';
import { ADMIN,TECHNICIAN } from '../../constants/routeConstants';

const SidebarConfigurable = (props) => {
    const navigate = useNavigate();
    const {userRole} = useContext(UserContext);
    const { pathname } = useLocation();
    const isFromUnauthorize = props.unauthorize;

    const [reportMap, setReportMap] = useState(new Map(props?.technicianCountData?.map((item, index) => {

        return (
            [item?.ReportName, item?.CountOfCases ?? 0]
        )
    })));


    useEffect(() => {
        const reportMapVar = new Map(props?.technicianCountData?.map((item, index) => {

            return (
                [item?.ReportName, item?.CountOfCases ?? 0]
            )
        }))
        setReportMap(new Map(props?.technicianCountData?.map((item, index) => {

            return (
                [item?.ReportName, item?.CountOfCases ?? 0]
            )
        })));

    }, [props?.technicianCountData])


    const selectedReports = [
        [DUAL_ACCOUNT_REPORT, INBOUND_CORR_WB_REPORT, PART_D_DUPLICATE_REPORT, PART_D_IE_REPORT, PART_D_MULTIPLE_REPORT, RESOLVED_COMPLETED_REPORT, TRANSITIONAL_OVERRIDE_REPORT, UHCEI_DUPLICATE_DENIAL_REPORT, XCPINDEXING_REPORT, PART_D_PREDETERMINATION_REPORT]
        // ['Part D PreDetermination', 'Resolved-Dismissed', 'Transitional Override'],
        // ['UHCEI Duplicate Denial', 'xCP Indexing Report']
    ];
    const checkColorForReport = () => {
        if (userRole == ADMIN) {
            if (pathname == "/configurable")
                return true;
        }
        if (userRole == TECHNICIAN) {
            if (pathname == "/" || pathname == "/configurable")
                return true;
        }
        return false;
    }

    let { report: reportStateVariable } = useLocation().state || { report: null };
    if (reportStateVariable == null || reportStateVariable == undefined) {
        if (checkColorForReport() == true) {
            reportStateVariable = DUAL_ACCOUNT_REPORT;
        }
    }
    const getRandomReport = () => {
        const randomIndex = Math.floor(Math.random() * selectedReports.length);
        return selectedReports[randomIndex];
    };
    const handleWorkbenchNavigation = (report) => {
        navigate('/configurable', {
            state: {
                report: report
            }
        })
    }

    return (
        <div className={classes.sidebar}>
            <div className={classes.sidebarHeading}>
                <Typography component="p" sx={{ color: '#ff4400', fontSize: '2.5rem' }}>Optum</Typography>
                <Typography component="p">Retro Quality Audit</Typography>
            </div>
            {
                isFromUnauthorize != true &&
                <div className={classes.sideBarLinks}>
                    <Button variant='contained' fullWidth disableElevation>Reports</Button>
                    <div className={classes.sideBarReportLinks}>
                        {selectedReports[0].map((report, index) => (
                              <Typography component="p" key={index} sx={{textAlign: 'left', fontSize: '0.8rem', cursor: 'pointer', my: 1,p:1, color: reportStateVariable == report ? '#ff612b' : '#002277' }} onClick={() => handleWorkbenchNavigation(report)}>{report}{props.isLoading||reportMap.get(report)===undefined?"":`(${reportMap.get(report)})`}</Typography> 
 
                        ))}
                    </div>
                </div>
            }
        </div>
    );
};

export default SidebarConfigurable;